"use client";

import Image from "next/image";
import AnimatedContent from "../AnimatedContent";
import { useTranslation } from "react-i18next";
import SectionContainer from "@/common/SectionContainer";

const StatusSection = () => {
  const { t } = useTranslation();
  const statusItems = [
    {
      icon: "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/status_content_icon.png",
      title: "STATUS_SECTION_ITEM_TITLE_1",
      description: "STATUS_SECTION_ITEM_DESCRIPTION_1",
    },
    {
      icon: "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/status_global_icon.png",
      title: "STATUS_SECTION_ITEM_TITLE_2",
      description: "STATUS_SECTION_ITEM_DESCRIPTION_2",
    },
    {
      icon: "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/status_increase_icon.png",
      title: "STATUS_SECTION_ITEM_TITLE_3",
      description: "STATUS_SECTION_ITEM_DESCRIPTION_3",
    },
  ];

  const imageSizes = "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw";

  return (
    <SectionContainer
      id="status-section"
      className="section-shell bg-white text-gray-900"
    >
      <AnimatedContent className="section-inner section-stack items-center text-center">
        {/* Title */}
        <div className="section-head">
          <h2 className="section-title">{t("STATUS_SECTION_TITLE")}</h2>
          <p className="caption text-gray-600 section-lead">
            {t("STATUS_SECTION_SUB_TITLE_1")}
            <br className="hidden sm:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#5BBF4D] to-[#207AE8] font-bold">
              Color to Life
            </span>
            {t("STATUS_SECTION_SUB_TITLE_2")}
          </p>
        </div>
        {/* </div> */}

        {/* 아이콘 3열 블록 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
          {statusItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center gap-6 p-10 sm:p-12 rounded-2xl border border-gray-100 bg-gradient-to-b from-white to-gray-50 shadow-sm hover:shadow-md transition-all duration-300"
            >
              {/* 아이콘 */}
              <div className="relative w-16 h-16 md:w-20 md:h-20">
                <Image
                  src={item.icon}
                  alt={item.title}
                  fill
                  sizes={imageSizes}
                  className="object-contain"
                />
              </div>

              {/* 제목 */}
              <div className="bg-gradient-to-r from-[#5BBF4D]/80 to-[#207AE8]/80 text-white font-semibold text-[clamp(1rem,1.8vw,1.25rem)] py-1 px-4 rounded-xl shadow-sm">
                {t(item.title)}
              </div>

              {/* 설명 */}
              <p className="text text-gray-700 max-w-[320px]">
                {t(item.description)}
              </p>
            </div>
          ))}
        </div>
      </AnimatedContent>
    </SectionContainer>
  );
};

export default StatusSection;
